import { Theme, WithStyles } from "@material-ui/core";
import { bindActions, mockTheme } from "../utils/utils";
import * as React from "react";
import { ComponentClass } from "react";
import Grid from "@material-ui/core/Grid";
import { AdminActions, IAdminStore } from "../store/admin";
import { SortDirection } from "@material-ui/core/TableCell";
import AsyncTable, { ColumnDefinition } from "../components/AsyncTable";
import { IStore } from "../store";
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";
import { JSONSchema6 } from "json-schema";
import EnhancedSchemaForm from "../components/schemaForm";
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { ISubmitEvent, UiSchema } from 'react-jsonschema-form';
import Paper from '@material-ui/core/Paper';
import { Edit } from "@material-ui/icons";
import { getApi } from "src/api/ApiProvider";
import { BranchData } from "src/components/BranchSelector";



const styles = (theme: Theme) => ({
    container: {
        display: "flex",
        flexWrap: "wrap",
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: `calc(50% - ${theme.spacing.unit * 3}px)`,
    },
    menu: {
        width: 200,
    },

    routeSelector: {
        width: "100%",
        height: "100%"
    },
    buttons: {
        marginLeft: "auto",
    },
    abm: {
        padding: theme.spacing.unit * 3,
        margin: theme.spacing.unit,
    }
});


/**
 * This is a hack to has a object with the keys the same as the return of the #createStyles
 */
const classesType = styles(mockTheme);

interface AdminsProps extends WithStyles<keyof typeof classesType> {

    actions: AdminActions;
    data: IAdminStore;

}

interface AdminsState {
    abm: {
        name: string;
        document: string;
        email: string;
        open: boolean;
        select?: object;
        openEdit: boolean;
        openPassword: boolean;
        password: string;
    },
    table: {
        data: any,
        sortBy: string,
        sortDirection: SortDirection
    }
    schema: JSONSchema6;
    branch: BranchData[];
    roles: any[];
}

const schema: JSONSchema6 = {
    definitions: {
        user: {
            type: "object",
            required: ["name", "email", "pass"],
            properties: {
                name: { type: "string", title: "Nombre" },
                email: { type: "string", title: "Correo" },
            }
        }
    },
    title: "Administrador",
    type: "object",
    required: ["user"],
    properties: {
        user: { title: "Datos", "$ref": "#/definitions/user" },
        pass: { type: "string", title: "Contraseña", format: "password" },
        branch: {
            type: 'number', title: 'Sucursal',
            anyOf: [{ type: "number", enum: [0], title: "Cargando" }],
            default: 0
        },
        rol: {
            type: 'string', title: 'Roles',
            anyOf: [{ type: "string", enum: [0], title: "Cargando" }],
            default: 0
        },
    }
};

const uiSchema: UiSchema = {
    pass: {
        "ui:widget": "password",
        "ui:help": "Usa un password complejo"
    },
};
const rolesData = [
    { id: 'ROLE_ADMIN', name: 'Super admin' },
    { id: 'ROLE_COMPANY_MANAGER', name: 'Administrador de Empresa' },
    { id: 'ROLE_BRANCH_MANAGER', name: 'Administrador de Sucursal' },

]

class Admins extends React.Component<AdminsProps, AdminsState> {

    columnData = [
        {
            path: '', numeric: true, label: "Editar", draw: (cd: ColumnDefinition, data: object) => {
                return (
                    <IconButton aria-label='Editar' title='Editar'
                        onClick={this.edit(data)}>
                        <Edit />
                    </IconButton>
                );
            }
        },
        { path: "user.name", numeric: false, disablePadding: true, label: "Nombre" },
        { path: "user.email", numeric: false, disablePadding: false, label: "Correo" },
        { path: "branch.name", numeric: false, disablePadding: false, label: "Sucursal" },
        {
            path: "rol", numeric: false, disablePadding: false, label: "Rol",
            draw: (cd: ColumnDefinition, data: any) => {
                const role = rolesData.find(rol => rol.id === data.rol);
                return <label>{role ? role.name : 'Desconocido'}</label>;
            }
        },

    ];

    constructor(props: AdminsProps) {
        super(props);

        this.state = {
            abm: {
                name: '',
                document: '',
                email: '',
                open: false,
                openEdit: false,
                openPassword: false,
                password: ''
            },
            table: {
                data: [],
                sortBy: "name",
                sortDirection: "desc"
            },
            schema: schema,
            branch: [],
            roles: [],
            

        };
        Promise.all([
            getApi().branch().listAllBranchesAdmin()
        ]).then(([branchData]) => {

            const newSchema: JSONSchema6 = JSON.parse(JSON.stringify(schema));
            const branch = newSchema.properties!.branch as JSONSchema6;
            branch.anyOf = branchData.map((d: any) => {
                return { type: "number", enum: [d.id], title: d.name + '-' + d.company.name || '' } as JSONSchema6
            });
            const roles = newSchema.properties!.rol as JSONSchema6;
            roles.anyOf = rolesData.map(d => {
                return { type: "string", enum: [d.id], title: d.name || '' } as JSONSchema6
            });

            this.setState({ schema: newSchema, branch: branchData, roles: rolesData });
        });


        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSubmitEdit = this.handleSubmitEdit.bind(this);
        this.showDialog = this.showDialog.bind(this);
        this.hideDialog = this.hideDialog.bind(this);
        this.hidePasswordDialog = this.hidePasswordDialog.bind(this);
        this.changePassword = this.changePassword.bind(this);
    }

    handleSubmit(e: ISubmitEvent<any>) {
        const dato = {
            name: e.formData.user.name,
            email: e.formData.user.email,
            pass: e.formData.pass,
            branchObject: this.state.branch.find(data => data.id === e.formData.branch),
            rol: e.formData.rol,
        }
        this.props.actions.add(dato);
        this.props.actions.fetch();
        this.hideDialog();
    }

    handleSubmitEdit(e: ISubmitEvent<any>) {
        console.info("Dato a enviar: ", e.formData);
        const dato = {
            name: e.formData.user.name,
            email: e.formData.user.email,
            pass: e.formData.pass,
            branchObject: this.state.branch.find(data => data.id === e.formData.branch),
            rol: e.formData.rol,
        }
        this.props.actions.edit(dato, e.formData.id);
        this.props.actions.fetch();
        this.hideDialog();
    }

    changePassword() {
        const selected: any = this.state.abm.select;
        const password = this.state.abm.password;
        if (!selected || !selected.id || !password) {
            return;
        }

        this.props.actions.changePassword(selected.id, password, this.hidePasswordDialog);
    }

    edit(data: any) {
        const newSchema: JSONSchema6 = JSON.parse(JSON.stringify(schema));
        const roles = newSchema.properties!.rol as JSONSchema6;
        roles.anyOf = rolesData.map(d => {
            return { type: "string", enum: [d.id], title: d.name || '' } as JSONSchema6
        });
        const branch = newSchema.properties!.branch as JSONSchema6;
        branch.anyOf = this.state.branch.map(d => {
            return { type: "number", enum: [d.id], title: d.name + '-' + d.company.name || '' } as JSONSchema6
        });

        // this.setState({ schema: newSchema });
        delete newSchema.properties!.pass; // Elimina la propiedad pass del esquema
        const userDefinition = newSchema.definitions!.user as JSONSchema6;
        userDefinition.required = userDefinition && userDefinition.required ? userDefinition.required.filter((field: string) => field !== 'pass') : []; // Elimina pass de required
        return (event: React.MouseEvent<HTMLElement>) => {
            this.setState({
                schema: newSchema,
                abm: {
                    ...this.state.abm,
                    select: {
                        ...data,
                        branch: data.branch && data.branch.id || '', // Preselecciona la sucursal
                        email: data.user.email || '',
                        rol: `${data.rol}` || '',
                    },
                    openEdit: true,
                }
            }, () => console.info("Editando: ", this.state.abm.select, this.state.schema));
        }
    }

    sort(name: string) {
        return () => {
            this.setState({
                ...this.state,
                table: {
                    ...this.state.table,
                    sortBy: name,
                    sortDirection: "desc"
                }
            })

        }

    }

    componentDidMount() {
        this.props.actions.fetch();
    }


    hideDialog() {
        this.setState({
            abm: {
                ...this.state.abm,
                open: false,
                openEdit: false,
                openPassword: false,
                password: ''
            }
        });
    }

    hidePasswordDialog() {
        this.setState({
            abm: {
                ...this.state.abm,
                openPassword: false,
                password: ''
            }
        });
    }

    showDialog() {
        this.setState({
            abm: {
                name: '',
                email: '',
                document: '',
                open: true,
                openEdit: false,
                openPassword: false,
                password: ''
            }
        });
    }

    render() {

        return (
            <Grid container spacing={24}>
                <Grid item sm={12}>
                    <AsyncTable
                        columnDefinition={this.columnData}
                        showFiltro={true}
                        title="Administradores"
                        data={this.props.data.data.data}
                        defaultOrder={{
                            name: "name",
                            direction: "desc"
                        }}
                        headerButtons={(
                            <Tooltip title="Agregar">
                                <IconButton aria-label="Agregar" onClick={this.showDialog}>
                                    <AddIcon />
                                </IconButton>
                            </Tooltip>
                        )} />

                </Grid>
                <Dialog open={this.state.abm.open}
                    maxWidth="md"
                    fullWidth={true}
                >
                    <Paper className={this.props.classes.abm}>
                        <EnhancedSchemaForm
                            schema={this.state.schema}
                            onSubmit={this.handleSubmit}
                            uiSchema={uiSchema}
                        >
                            <Grid container justify="space-around">
                                <Grid item>
                                    <Button variant="contained" onClick={this.hideDialog}>
                                        Cancelar
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button variant="contained" color="primary" type="submit">
                                        Aceptar
                                    </Button>
                                </Grid>
                            </Grid>
                        </EnhancedSchemaForm>
                    </Paper>
                </Dialog>
                <Dialog open={this.state.abm.openEdit} maxWidth="md" fullWidth={true}>
                    <Paper className={this.props.classes.abm}>
                        <EnhancedSchemaForm
                            schema={this.state.schema}
                            onSubmit={this.handleSubmitEdit}
                            formData={this.state.abm.select}
                            uiSchema={uiSchema}>
                            <Grid container justify="space-around">
                                <Grid item>
                                    <Button variant="contained" onClick={() => this.setState({ abm: { ...this.state.abm, openPassword: true, password: '' } })}>
                                        Cambiar password
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button variant="contained" onClick={this.hideDialog}>
                                        Cancelar
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button variant="contained" color="primary" type="submit">
                                        Aceptar
                                    </Button>
                                </Grid>
                            </Grid>
                        </EnhancedSchemaForm>
                    </Paper>
                </Dialog>
                <Dialog open={this.state.abm.openPassword} maxWidth="sm" fullWidth={true}>
                    <Paper className={this.props.classes.abm}>
                        <TextField
                            autoFocus
                            fullWidth
                            type="password"
                            label="Nuevo password"
                            value={this.state.abm.password}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => this.setState({
                                abm: { ...this.state.abm, password: event.target.value }
                            })}
                        />
                        <Grid container justify="space-around" style={{ marginTop: 24 }}>
                            <Grid item>
                                <Button variant="contained" onClick={this.hidePasswordDialog}>
                                    Cancelar
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button variant="contained" color="primary" disabled={!this.state.abm.password} onClick={this.changePassword}>
                                    Guardar password
                                </Button>
                            </Grid>
                        </Grid>
                    </Paper>
                </Dialog>
            </Grid>
        );
    }
}

const mapStateToProps = (state: IStore, ownProps: AdminsProps) => ({
    ...ownProps,
    data: state.admin,
});


const styled = withStyles(styles as any)(Admins);
const connected = connect(mapStateToProps, bindActions(AdminActions))(styled);

export default connected as ComponentClass<Partial<AdminsProps>>;



// WEBPACK FOOTER //
// ./src/pages/admin.tsx